import React, { createContext, useContext, useEffect, useState } from "react"
import { useAuth } from "@/contexts"
import { PortalRole, ViewerContextType } from "@/types"

const ViewerContext = createContext<ViewerContextType | null>(null)

export const ViewerProvider = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth()
  const [clientId, setClientId] = useState<number | null>(null)
  const [returnPath, setReturnPath] = useState<string | null>(null)

  useEffect(() => {
    if (user?.userType === PortalRole.CLIENT) {
      setClientId(user.id)
    }
  }, [user])

  const startImpersonation = (clientId: number, currentPath: string) => {
    setClientId(clientId)
    setReturnPath(currentPath)
  }

  const stopImpersonation = () => {
    setClientId(null)
    const path = returnPath
    setReturnPath(null)
    return path
  }

  if (loading) {
    return <div>Loading...</div>
  }

  return (
    <ViewerContext.Provider
      value={{
        clientId,
        isImpersonating: user?.userType !== PortalRole.CLIENT,
        setClientId,
        returnPath,
        startImpersonation,
        stopImpersonation,
      }}
    >
      {children}
    </ViewerContext.Provider>
  )
}

export const useViewer = () => {
  const ctx = useContext(ViewerContext)
  if (!ctx) throw new Error("useViewer must be used within ViewerProvider")
  return ctx
}